var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"pause",class:[_vm.isSelected, _vm.isDisabled, _vm.classInput],on:{"pointerdown":_vm.enableButton}},[_vm._v(" "+_vm._s(_vm.duration)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }